export default {
  HOT: undefined,
  NEW: 'new',
  RISING: 'rising',
  CONTROVERSIAL: 'controversial',
  TOP: 'top',
};



// WEBPACK FOOTER //
// ./src/enums/modifiers.js